import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  makeStyles,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import { gpColors } from "../../../constants/colors";
import SideDrawer from "../Drawer";
import { getCookie } from "../../../Functions";
import CryptoAES from "crypto-js/aes";
import CryptoENC from "crypto-js/enc-utf8";
import AddProductValMOdal from "../AddProductValMOdal";
import { useLocation, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import Cookies from "js-cookie";
import api from "../../Interceptors/axiosInstance";
import {routes} from "../../../constants/routes";

const useStyles = makeStyles((theme) => ({
  roots: {
    width: "100%",
    display: "flex",
    height: "auto",
    backgroundColor: "#EAE4E8",
  },
  content: {
    width: "100%",
    height: "auto",
    flexGrow: 1,
    paddingTop: "84px",
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  title: {
    fontSize: "20px",
    fontWeight: 600,
    paddingBottom: 20,
  },
  root: {
    minHeight: "280px",
    marginTop: "20px",
  },
  containerExportRow: {
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column-reverse",
      alignItems: "flex-start !important",
    },
  },
  containerHeaderBox: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  exportButton: {
    backgroundColor: gpColors.logoBrown,
    color: "#fff",
    marginBottom: "12px",
    width: "30%",
    padding: "5px 30px",
    "&.MuiButtonBase-root": {
      "&:hover": { backgroundColor: gpColors.logoBrown },
    },
    [theme.breakpoints.down("sm")]: {
      width: "60%",
    },
  },
  deleteLink: {
    color: "#F22F46",
    cursor: "pointer",
    textDecoration: "none",
    fontSize: "0.875rem",
    fontWeight: "bold",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  editLink: {
    color: "rgb(23, 94, 170)",
    cursor: "pointer",
    textDecoration: "none",
    fontSize: "0.875rem",
    fontWeight: "bold",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  input: {
    "& .MuiOutlinedInput-input": {
      padding: "10.5px 10px",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "10px",
    },
    // color: '#000'
  },
}));

const ContainerParts = () => {
  const classes = useStyles();
  const [userData, setUserData] = useState({});
  const [loader, setLoader] = useState(false);
  const [containerData, setContainerData] = useState([]);
  const [btnLoader, setBtnLoader] = useState(false);
  const [drawerClose, setDrawerClose] = useState(false);
  const [token, setToken] = useState();
  const [cbm, setCbm] = useState("");
  const [scanCount, setScanCount] = useState("");
  const [oldScanCount, setOldScanCount] = useState("");
  const [partNumber, setPartNumber] = useState("");
  const [newScanCount, setNewScanCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedLocationId, setSelectedLocationId] = useState("");

  const location = useLocation();
  const containerId = location.state?.containerId;
  const cId = location.state?.cId;
  const [alert, setAlert] = useState({
    alertStatus: false,
    alertMessage: "",
    alertColor: "",
  });

  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [isEditDelete, setIsEditDelete] = useState(false);
  const navigate = useNavigate();
  //   filter data base on search data
  const filteredData = Array.isArray(containerData)
    ? containerData.filter(
        (item) =>
          item.partNo
            ?.toString()
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          item.brandName
            ?.toString()
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          item.scansCount
            ?.toString()
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          item.noOfPcs
            ?.toString()
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          item.totalCBM
            ?.toString()
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          item.shipToLocation
            ?.toString()
            .toLowerCase()
            .includes(searchTerm.toLowerCase())
      )
    : [];

  const columns = [
    {
      name: "Part No",
      selector: (row) => row.partNo,
      sortable: true,
      center: true,
    },
    {
      name: "Brand Name",
      selector: (row) => row.brandName,
      sortable: true,
      center: true,
    },
    {
      name: "Scans Count",
      selector: (row) => row.scansCount,
      sortable: true,
      center: true,
    },
    {
      name: "No. of Pcs",
      selector: (row) => row.noOfPcs,
      sortable: true,
      center: true,
    },
    {
      name: "Total CBM",
      selector: (row) => row.totalCBM,
      sortable: true,
      center: true,
    },
    {
      name: "Ship To Location",
      selector: (row) => row.shipToLocation || "N/A",
      sortable: true,
      center: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: 10,
          }}
        >
          <span
            className={classes.editLink}
            onClick={() => handleEditModal(row,)}
          >
            Edit
          </span>
          <span
            className={classes.deleteLink}
            onClick={() => handleDeleteModal(row.partNo, row.shipToLocId)}
          >
            Delete
          </span>
        </Box>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      center: true,
    },
  ];

  const handleDeleteModal = (partNo, locId) => {
    setOpen(true);
    setPartNumber(partNo);
    setSelectedLocationId(locId);
  };
  const handleEditModal = (item,) => {
    console.log('cId: ', cId)
    navigate(routes.UPDATE_INWARD_SCAN, { state: { partNo: item.partNo, locId: item.shipToLocId, outwardScan : true, cId: cId } });
    // setOpenEdit(true);
    setScanCount(item.scansCount);
    setOldScanCount(item.scansCount);
    setPartNumber(item.partNo);
    setSelectedLocationId(item.shipToLocId);
  };

  const handleNewScanCount = (e) => {
    if (e.target.value) {
      const newValue = parseInt(e.target.value);
      if (newValue < 0) {
        setScanCount(scanCount);
      } else {
        setScanCount(newValue);
      }
    }
  };

  const handleClose = () => setOpen(false);
  const handleEditClose = () => setOpenEdit(false);

  const handleDelete = async () => {
    handleClose();
    const size = containerData.length;
    try {
      // const resp = await fetch(
      //   `${process.env.REACT_APP_API_ENDPOINT}/deleteByContainerIdAndPartNo?containerId=${containerId}&partNo=${partNumber}&size=${size}&locId=${selectedLocationId ? selectedLocationId : 0}`,
      //   {
      //     method: "POST",
      //     headers: {
      //       // "ngrok-skip-browser-warning": "true",
      //       Authorization: `Token ${userData.loginInfo.data.jwt}`,
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );
      const resp = await api.post(
        `deleteByContainerIdAndPartNo?containerId=${cId}&partNo=${partNumber}&size=${size}&locId=${
          selectedLocationId ? selectedLocationId : 0
        }`
      );
      const data = resp.data;
      if (data.result === "Success") {
        setAlert({
          ...alert,
          alertStatus: true,
          alertColor: "green",
          alertMessage: "Deleted successfully",
        });
        setIsEditDelete(true);
      } else {
        setAlert({
          ...alert,
          alertStatus: true,
          alertColor: "red",
          alertMessage: "Something went wrong please try after sometime.",
        });
      }
    } catch (error) {
      setAlert({
        ...alert,
        alertStatus: true,
        alertColor: "red",
        alertMessage: "An error occurred while deleting the data.",
      });
    }
  };

  const handleEditSave = async () => {
    handleEditClose();
    if (scanCount !== oldScanCount) {
      try {
        // const resp = await fetch(
        //   `${process.env.REACT_APP_API_ENDPOINT}/updateContainerData`,
        //   {
        //     method: "POST",
        //     body: JSON.stringify({
        //       containerId: containerId.trim(),
        //       partNo: partNumber.trim(),
        //       scansCount: scanCount,
        //       emailId: userData.username,
        //       shipToLocId: selectedLocationId ? selectedLocationId : 0,
        //     }),
        //     headers: {
        //       // "ngrok-skip-browser-warning": "true",
        //       Authorization: `Token ${userData.loginInfo.data.jwt}`,
        //       "Content-Type": "application/json",
        //     },
        //   }
        // );
        const resp = await api.post("/updateContainerData", {
          containerId: containerId.trim(),
          partNo: partNumber.trim(),
          scansCount: scanCount,
          emailId: userData.username,
          shipToLocId: selectedLocationId ? selectedLocationId : 0,
        });
        const data = await resp.data;

        if (data.result === "Success") {
          setAlert({
            ...alert,
            alertStatus: true,
            alertColor: "green",
            alertMessage: data.resultMessage || "Edited successfully",
          });
          setIsEditDelete(true);
        } else {
          setAlert({
            ...alert,
            alertStatus: true,
            alertColor: "red",
            alertMessage:
              data.resultMessage ||
              "Something went wrong please try after sometime.",
          });
        }
      } catch (error) {
        setAlert({
          ...alert,
          alertStatus: true,
          alertColor: "red",
          alertMessage: "An error occurred while editing the data.",
        });
      }
    }
  };

  const [validationModal, setValidationModal] = useState(false);
  function closeValidationModal() {
    setValidationModal(false);
  }
  // Alert box close
  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({
      ...alert,
      alertStatus: false,
      alertColor: "",
      alertMessage: "",
    });
  };

  //Getting cookies
  // const getLoginInfoData = () => {
  //   const getValue = getCookie("guardPlus_user");
  //   if (getValue !== null) {
  //     const decryptedValue = CryptoAES.decrypt(getValue, "secretKey");
  //     const userVal = JSON.parse(decryptedValue.toString(CryptoENC));
  //     setUserData(userVal);
  //     setToken(userVal.loginInfo.data.jwt);
  //   }
  // };
  // const sessionUsername = Cookies.get("userName");
      const sessionUsername = sessionStorage.getItem("userName");

  const getLoginInfoData = () => {
    setUserData({ username: sessionUsername });
  };
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    getLoginInfoData();
  }, []);

  useEffect(() => {
    if (containerId) {
      getAllContainerParts();
    }
  }, [containerId]);

  useEffect(() => {
    if (isEditDelete) {
      getAllContainerParts();
      setIsEditDelete(false);
    }
  }, [isEditDelete]);

  const getAllContainerParts = async () => {
    setLoader(true);
    try {
      // const resp = await fetch(
      //   `${process.env.REACT_APP_API_ENDPOINT}/getByContainerId?containerId=${containerId}&shipToLocId=0`,
      //   {
      //     method: "GET",
      //     headers: {
      //       // "ngrok-skip-browser-warning": "true",
      //       Authorization: `Token ${token}`,
      //     },
      //   }
      // );
      const resp = await api.get(`/getByContainerId?containerId=${containerId}&shipToLocId=0&contId=${cId}`);
      const data = await resp.data;
      setContainerData(data.resultData);
      setCbm(data.totalCBM);
    } catch (e) {
      console.log("Container Parts List Error--------------", e);
    } finally {
      setLoader(false);
    }
  };

  const printFunctionality = () => {
    setDrawerClose(true);
  };

  useEffect(() => {
    setTimeout(() => {
      if (drawerClose) {
        window.print();
        setDrawerClose(false);
      }
    }, 100);
  }, [drawerClose]);

  const exportContainerPartsData = async () => {
    setBtnLoader(true);
    try {
      // const response = await fetch(
      //   `${process.env.REACT_APP_API_ENDPOINT}/exportContainerDataById?containerId=${containerId}`,
      //   {
      //     method: "GET",
      //     headers: {
      //       // "ngrok-skip-browser-warning": "true",
      //       Authorization: `Token ${token}`,
      //     },
      //   }
      // );

      // if (response.ok) {
      //   const blob = await response.blob();
      //   const url = window.URL.createObjectURL(blob);
      //   const a = document.createElement("a");
      //   a.href = url;
      //   a.download = `Container_${containerId}.xlsx`;
      //   a.style.display = "none";
      //   document.body.appendChild(a);
      //   a.click();
      //   a.remove();
      //   window.URL.revokeObjectURL(url);
      // } else if (response.status === 404) {
      //   setAlert({
      //     ...alert,
      //     alertStatus: true,
      //     alertColor: "red",
      //     alertMessage: "No data found to generate Excel file.",
      //   });
      // } else {
      //   setAlert({
      //     ...alert,
      //     alertStatus: true,
      //     alertColor: "red",
      //     alertMessage: "An error occurred while exporting the data.",
      //   });
      // }
      const response = await api.get(`exportContainerDataById?containerId=${containerId}&contId=${cId}`, {
              responseType: "blob",
            });
      console.log('response: ', response)
            if (response && response.status === 200) {
              const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
      
              const a = document.createElement("a");
              a.href = url;
              a.download = `Container_${containerId}.xlsx`;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              a.remove();
      
              window.URL.revokeObjectURL(url);
            } else if (response.status === 404) {
              setAlert({
                ...alert,
                alertStatus: true,
                alertColor: "red",
                alertMessage: "No data found to generate Excel file.",
              });
            } else {
              setAlert({
                ...alert,
                alertStatus: true,
                alertColor: "red",
                alertMessage: response || "An error occurred while exporting the data.",
              });
            }
    } catch (error) {
      console.error("Error exporting containers:", error);
      setAlert({
        ...alert,
        alertStatus: true,
        alertColor: "red",
        alertMessage: "An error occurred while exporting the data.",
      });
    } finally {
      setBtnLoader(false);
    }
  };

  return (
    <Box className={classes.roots}>
      <SideDrawer
        tabName="containerDetails"
        userData={userData}
        drawerClose={drawerClose}
      />
      <main className={classes.content}>
        <Box
          className={classes.containerExportRow}
          style={{ display: "flex", width: "100%", alignItems: "center" }}
        >
          {/* Left Section */}
          <Box
            className={classes.containerHeaderBox}
            sx={{ width: "50%", display: "flex", justifyContent: "left" }}
          >
            <Typography className={classes.title}>
              Container - {containerId ? containerId : "N/A"}
            </Typography>
          </Box>
          {/* Right Section */}
          <Box
            style={{
              display: "flex",
              width: "50%",
              gap: "20px",
              justifyContent: "right",
            }}
          >
            <Button
              className={classes.exportButton}
              onClick={exportContainerPartsData}
            >
              {btnLoader ? <CircularProgress size={25} /> : "Export"}
            </Button>
            <Button
              className={classes.exportButton}
              onClick={printFunctionality}
            >
              Print
            </Button>
          </Box>
        </Box>

        <Typography className={classes.title}>
          Total CBM - {cbm ? cbm : "NA"}
        </Typography>
        <Divider />
        <Card className={classes.root}>
          <CardContent>
            {/* DataTable */}
            <div style={{ borderRadius: "20px" }}>
              {/* Search bar */}
              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    marginBottom: "10px",
                    padding: "10px",
                    width: "300px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                  }}
                />
              </Box>
              <div style={{ overflow: "hidden" }}>
                <DataTable
                  columns={columns}
                  data={filteredData || []}
                  progressPending={loader}
                  progressComponent={
                    <CircularProgress size={30} color="inherit" />
                  }
                  noDataComponent={
                    <div
                      style={{
                        color: "#F22F46",
                        fontWeight: 600,
                        marginTop: "20px",
                      }}
                    >
                      Data Not Exist
                    </div>
                  }
                  pagination
                  paginationPerPage={5}
                  paginationRowsPerPageOptions={[5, 10, 20, 50, 100]}
                  highlightOnHover
                  striped
                  persistTableHead
                  responsive
                  customStyles={{
                    headCells: {
                      style: {
                        backgroundColor: gpColors.logoGray,
                        color: "#fff",
                        fontWeight: "bold",
                        justifyContent: "center",
                      },
                    },
                    rows: {
                      style: {
                        fontSize: "0.875rem",
                      },
                    },
                  }}
                />
              </div>
            </div>
          </CardContent>
        </Card>
      </main>
      {/* Delete Modal */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 10,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography id="modal-description" variant="body1">
            Are you sure you want to delete this item?
          </Typography>
          <Box display="flex" justifyContent="space-between" mt={4}>
            <Button
              onClick={handleClose}
              style={{ backgroundColor: "rgb(54, 64, 75)", color: "#fff" }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleDelete}
              style={{ backgroundColor: "#F22F46", color: "#fff" }}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Edit Modal */}
      <Modal
        open={openEdit}
        onClose={handleEditClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 10,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
              id="modal-description"
              variant="body1"
              style={{ textAlign: "left" }}
            >
              No. of Boxes
            </Typography>
            <TextField
              className={classes.input}
              variant="outlined"
              value={scanCount}
              onChange={handleNewScanCount}
              type="number"
              inputProps={{ min: 0 }}
            />
          </Box>
          <Box display="flex" justifyContent="center" mt={4}>
            <Button
              onClick={handleEditSave}
              style={{
                backgroundColor: "#F22F46",
                color: "#fff",
                width: "70%",
              }}
            >
              Update
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Validation modal and alert box for API results component */}
      <AddProductValMOdal
        validationModal={validationModal}
        closeValidationModal={closeValidationModal}
        handleAlertClose={handleAlertClose}
        alert={alert}
      />
    </Box>
  );
};
export default ContainerParts;
